import { createAction, createAsyncAction } from 'typesafe-actions';

import * as types from './passwordConfiguration.actionsTypes';
import { PasswordConfiguration } from './passwordConfiguration.types';

const fetchPasswordConfiguration = createAsyncAction(
	types.GET_PASSWORD_CONFIGURATION_REQUEST,
	types.GET_PASSWORD_CONFIGURATION_SUCCESS,
	types.GET_PASSWORD_CONFIGURATION_FAILURE,
)<{ organizationID: string }, { passwordConfiguration: PasswordConfiguration }, { error: string }>();

const savePasswordConfiguration = createAsyncAction(
	types.SET_PASSWORD_CONFIGURATION_REQUEST,
	types.SET_PASSWORD_CONFIGURATION_SUCCESS,
	types.SET_PASSWORD_CONFIGURATION_FAILURE,
)<
	{ organizationID: string; passwordConfiguration: PasswordConfiguration },
	{ passwordConfiguration: PasswordConfiguration },
	{ error: string }
>();

const resetPasswordConfiguration = createAction(types.RESET_PASSWORD_CONFIGURATION)();

export { fetchPasswordConfiguration, savePasswordConfiguration, resetPasswordConfiguration };
